<template>
  <div class="auth">
    <!-- Content -->
    <div class="auth__content" id="kt_login">
      <router-view></router-view>
    </div>

    <!-- Aside -->
    <div
      class="auth__aside"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    >
      <div class="auth__aside--content">
        <a href="#" class="auth__aside--logo">
          <img src="media/logos/logo-letter-2.png" />
        </a>
        <h3 class="auth__aside--text">
          <div class="auth__aside--text--title">Soluciones de datos</div>
          <div class="auth__aside--text--sub-title">que generan valor</div>
        </h3>
        <div class="auth__aside--footer">Bienvenido</div>
      </div>
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/auth.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "auth",
  methods: {},
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/bg-4.jpg";
    }
  }
};
</script>
